import { VStack, Text, Divider } from "@chakra-ui/react";
import L from "leaflet";
import { GeoJSON, Popup } from "react-leaflet";
import { GeoJsonObject, FeatureCollection } from "geojson";
import { PostOuvidoriaInformativo } from "store/modules/ouvidoria/informativo/actions/getInformativesGeojson";
import informativePin from "_assets/imgs/mapa/markers/map-icon-green.png";
import { useState } from "react";

const informativeIcon = new L.Icon({
  iconUrl: informativePin,
  iconSize: [30.48, 50],
  iconAnchor: [15.24, 50],
  shadowSize: [61, 61]
});

type PopupInformativo = PostOuvidoriaInformativo & { lat: number; lng: number };

export function InformativoGeojson({
  featureCollection
}: {
  featureCollection: FeatureCollection<GeoJSON.Point, PostOuvidoriaInformativo>;
}) {
  const [popup, setPopup] = useState<PopupInformativo | null>(null);

  return (
    <>
      <GeoJSON
        key={JSON.stringify(featureCollection)}
        data={featureCollection as GeoJsonObject}
        pointToLayer={(feature, latlng) => {
          return L.marker(latlng, { icon: informativeIcon });
        }}
        eventHandlers={{
          click: (f) => {
            setPopup({
              ...f.layer.feature.properties,
              lat: f.latlng.lat,
              lng: f.latlng.lng
            });
          }
        }}
      />
      {popup && (
        <Popup
          offset={[0, -40]}
          position={[popup.lat, popup.lng]}
          onClose={() => setPopup(null)}
        >
          <VStack p={2} justify="flex-start" align="flex-start">
            <Text fontSize="xl" fontWeight="semibold">
              Informativo
            </Text>
            <Text fontSize="md" fontWeight="medium">
              {popup.titulo}
            </Text>
            <Divider my={1} />
            <Text fontSize="sm">
              Endereço: {popup.endereco.logradouro}, {popup.endereco.bairro} -{" "}
              {popup.endereco.municipio}
            </Text>
          </VStack>
        </Popup>
      )}
    </>
  );
}
